type Config = {
  apiURL: string,
  hotelID: string,

};
let CONFIG: Config = {
  apiURL: 'http://test.vsc24.eu:8080/vscHotelBook',
  hotelID: 'Toshiba',
};

// npm install typings --global
// https://stackoverflow.com/questions/50488121/typescript-add-functions-to-window-with-d-ts-file

interface WindowInterface extends Window {
  config: Config;
}

let window2config = () => { // uruchamiane w App : render()
  var config: Config = (window as unknown as WindowInterface).config || {
    // gdy nie ma public/config.js, ustawiam na parametry z kompilacji - def. wyżej
    apiUrl: CONFIG.apiURL,
    hotelID: CONFIG.hotelID,
  
  }
  CONFIG.apiURL = config.apiURL;
  CONFIG.hotelID = config.hotelID;
}

export { window2config }
export default CONFIG;
